module.exports = "https://web-assets.ifttt.com/packs/media/docs/feederror-f645b509.png";